import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import HeaderProfile from "./HeaderProfile";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-header-profile")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<HeaderProfile />
		</ThemeProvider>
	</StrictMode>
);
